import { isEmpty } from "lodash";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  retrieveContact,
  retrieveContactPaymentType,
  toggleIncompletePaymentWarning,
} from "store/features/contact.store";
import useSystemState from "./useSystemState";

const useActivePaymentsHandler = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { isSystemLoading, isSystemLoadingFailed } = useSystemState();

  const contact = useSelector(retrieveContact);
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  const onToggleWarning = useCallback(
    (flag) => dispatch(toggleIncompletePaymentWarning({ value: flag, location: location.pathname })),
    [dispatch, location.pathname]
  );

  useEffect(() => {
    if (isSystemLoading || isSystemLoadingFailed) onToggleWarning(false);
    else if (isEmpty(contact)) onToggleWarning(false);
    else if (!isCheckoutPaymentType) onToggleWarning(false);
    else if (contact.activePayments === 0) onToggleWarning(false);
    else onToggleWarning(true);
  }, [contact, isCheckoutPaymentType, isSystemLoading, isSystemLoadingFailed, location.pathname, onToggleWarning]);
};

export default useActivePaymentsHandler;
